import { PowerUpEnum } from "./PowerUp"

export type PowerUpCount = { [key in PowerUpEnum]: number }

export default class PowerUpCollection {
  private _powerUpCount: PowerUpCount
  get powerUpCount() {
    return this._powerUpCount
  }

  constructor(params: PowerUpCount = {
    powerUpBomb: 0,
    powerUpSkates: 0,
    powerUpKick: 0,
    powerUpPunch: 0,
    powerUpFire: 0
  }) {
    this._powerUpCount = params
  }

  getPowerupTypesList(): PowerUpEnum[] {
    return Object.entries(this._powerUpCount).reduce<PowerUpEnum[]>((acc, [type, count]) => {
      for (let i = 0; i < count; i++) {
        acc.push(type as PowerUpEnum)
      }
      return acc
    }, [])
  }
}
